jQuery(document).ready(function ($) {

  
    function getNextAllowedDay() {
      var next_allowed_day = new Date();
      next_allowed_day.setDate(next_allowed_day.getDate() + 2);
      
      if (next_allowed_day.getDay() == 0) {  // SO
        next_allowed_day.setDate(next_allowed_day.getDate() + 1);
      } else if (next_allowed_day.getDay() == 6) {  // SA
        next_allowed_day.setDate(next_allowed_day.getDate() + 2);
      }
      
      var dd = next_allowed_day.getDate().toString();
      var mm = (next_allowed_day.getMonth()+1).toString();
      
      return (dd[1] ? dd : '0'+dd[0]) + '.'  +  (mm[1] ? mm : '0'+mm[0])  +  '.' + next_allowed_day.getFullYear();
    }
  
  
    //$(".js-form-item-auszahlungstermin-optionen:first-of-type label:first-of-type, #edit-auszahlungstermin-optionen-schnellstmglich--description").click(function() {  // line not working because of ajax form
    $(document).on("click", ".js-form-item-auszahlungstermin-optionen:first-of-type label:first-of-type, .form-item-auszahlungstermin-optionen:first-of-type .webform-element-description", function() { 
      $( ".form-item-gewuenschtes-auszahlungsdatum input[name='gewuenschtes_auszahlungsdatum']" ).val( getNextAllowedDay() );
    });
    
    $(document).on("click", ".form-item-auszahlungstermin-optionen2:first-of-type label:first-of-type, .form-item-auszahlungstermin-optionen2:first-of-type .webform-element-description", function() {  
      $( ".form-item-gewuenschtes-auszahlungsdatum2 input[name='gewuenschtes_auszahlungsdatum2']" ).val( getNextAllowedDay() );
    });
    
});
